import { z } from "zod";

import { ShippingRateDtoSchema } from "../dtos/shipping-rates";

export const ShippingRateFeSchema = ShippingRateDtoSchema.extend({
  amount: z.number().nullish(),
});

export type ShippingRateFe = z.infer<typeof ShippingRateFeSchema>;
